import { fetchWrapper } from "../Helpers/fetch-wrapper";
import { toApiPage } from "./queryParams";
const buildFilterParams = (filters = {}) => {
  const params = [];

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      const ids = value.map((ele) => ele?.id ?? ele).filter(Boolean);
      if (ids.length > 0) params.push(`filters[${key}]=[${ids.join(",")}]`);
    } else if (typeof value === "string" && value) {
      params.push(`filters[${key}]=${encodeURIComponent(value)}`);
    } else if (typeof value === "number") {
      params.push(`filters[${key}]=${value}`);
    }
  });

  return params;
};

const withDefaultOrganisationFilter = (filters = {}, authUser, isSuper) => {
  const nextFilters = { ...(filters || {}) };

  if (typeof nextFilters.organisation_id === "undefined" && nextFilters.organisation !== "" && !isSuper && authUser?.organisation_id) {
    nextFilters.organisation_id = authUser.organisation_id;
  }

  return nextFilters;
};

const getAllPacks = async (
  page,
  pageSize,
  sortBy,
  sortOrder,
  filters,
  authUser,
  isSuper
) => {
  const effectiveFilters = withDefaultOrganisationFilter(filters, authUser, isSuper);
  const params = buildFilterParams(effectiveFilters);
  const apiSortBy = {
    pack_reference: "pack_number",
    planned_start_date: "location.planned_start_date",
    planned_end_date: "location.planned_end_date",
  }[sortBy] || sortBy;

  if (page || page === 0) params.unshift("page=" + toApiPage(page));
  if (pageSize) params.push("pageSize=" + pageSize);
  if (apiSortBy) params.push("sortBy=" + apiSortBy);
  if (sortOrder) params.push("sortOrder=" + sortOrder);

  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/pack${
      params.length ? "?" + params.join("&") : ""
    }`
  );
};

const getPackById = async (id) => {
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${id}`
  );
  return response;
};

const searchPacks = async (query, organisationId) => {
  const params = new URLSearchParams({ q: query });
  if (organisationId) params.set("organisation_id", organisationId);

  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/search?${params.toString()}`
  );
};

const createPack = async (params) => {
  const response = fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/pack`,
    {
      id: params.id || undefined,
      data: params.data || undefined
    }
  );
  return response;
};

const updatePack = async (id, params) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${id}`,
    {
      data: params.data || undefined,
    }
  );
  return response;
};

const updateStatus = async (id, params) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${id}/status`,
    {
      status: params.status || undefined,
      reason: params.reason || undefined,
    }
  );
  return response;
};

const updateESUsers = async (id, params) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${id}/reassign`,
    {
      esusers: params?.newPackData?.users || undefined,
      equipment_placement_removal: params?.newPackData?.forms?.equipment_placement_removal || undefined,
      record_of_movement: params?.newPackData?.forms?.record_of_movement || undefined,
      start_date: params?.newPackData?.start_date ? params.newPackData.start_date : undefined,
      end_date: params?.newPackData?.end_date ? params.newPackData.end_date : undefined,
      current_status: params?.newPackData?.status || undefined,
    }
  );
  return response;
};


const getStatus = async () => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/packstatus`
  );
}

const packCount = async () => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/pack-count`
  );
}

const duplicateForTemp = async (pack_id, edit = false) => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${pack_id}/duplicatefortemp?edit=${edit}`
  );
}

const getUpload = async (pack_id, upload) => {
  return fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${pack_id}/getUpload`,
    {
      path: upload.path || undefined,
      disk: upload.disk || undefined
    }
  );
}

const latestExport = async (id) => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/latest-export/${id}`
  );
}

const exportPack = async (id) => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/export-pack/${id}`
  );
}

const startExport = async (id) => {
  return fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${id}/export`
  );
}

const exportStatus = async (id) => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/pack/${id}/export`
  );
}

const exportToCsv = async (sortBy, sortOrder, filters, exportColumns, authUser, isSuper, format) => {
  const effectiveFilters = withDefaultOrganisationFilter(filters, authUser, isSuper);
  const params = buildFilterParams(effectiveFilters);

  if (sortBy) params.push("sortBy=" + sortBy);
  if (sortOrder) params.push("sortOrder=" + sortOrder);

  if (exportColumns && exportColumns.length > 0) {
    exportColumns.forEach((col) => {
      params.push(`columns[]=${encodeURIComponent(col)}`);
    });
  }

  if (format?.value) {
    params.push(`format=${format?.value}`);
  }

  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/export-to-csv${
      params.length ? "?" + params.join("&") : ""
    }`
  );
};

export const PackService = {
  getAllPacks,
  getPackById,
  searchPacks,
  createPack,
  updatePack,
  updateStatus,
  updateESUsers,
  getStatus,
  duplicateForTemp,
  getUpload,
  latestExport,
  exportPack,
  startExport,
  exportStatus,
  packCount,
  exportToCsv
};

